export enum ProfileScreenNames {
  MAIN = 'profile',
  PROFILE = 'my_profile',
  ACCOUNT_PROFILE = 'my_account_profile',
  ACCOUNT_GALLERY = 'my_account_gallery',
  CHANGE_ACCOUNT_DETAILS = 'change_account_details',
  EDIT_USER = 'edit_user',
  BRANCH_CONTACT = 'branch_contact',
}
